import { UserManager } from 'oidc-client';
import settings from './settings';
import signin from './signin';

export default () =>  {
  const mngr =  new UserManager(settings);
  signin(mngr);

  mngr.events.addAccessTokenExpired(() => {
    mngr.signinRedirect()
  });
};